import { c as _c } from "react/compiler-runtime";
import { Details } from '@repo/ui/Details';
import { MaskIcon } from '@repo/ui/primitives/MaskIcon';
import { type PropsWithChildren, type ReactNode, useId } from 'react';
import * as styles from '../styles';
import { AccordionAnalyticsTracker } from './AccordionAnalyticsTracker';
type AccordionProps = {
  analyticsKey: 'rewards-breakdown' | 'card-details' | 'nw-take';
  iconComponent: ReactNode;
  title: string;
  analyticsActionName: string;
  actionSection: string;
  productSlug?: string;
  expandedByDefault?: boolean;
};
export function Accordion(t0) {
  const $ = _c(27);
  const {
    analyticsKey,
    children,
    iconComponent,
    title,
    analyticsActionName,
    actionSection,
    productSlug,
    expandedByDefault
  } = t0;
  const idSuffix = useId();
  const baseId = `${analyticsKey}-${productSlug || idSuffix}`;
  const detailsId = `card-accordion-${baseId}`;
  let t1;
  if ($[0] !== title) {
    t1 = <span className={styles.accordionSummaryTitle}>{title}</span>;
    $[0] = title;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== iconComponent || $[3] !== t1) {
    t2 = <span className={styles.accordionSummaryInner}>{iconComponent}{t1}</span>;
    $[2] = iconComponent;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <MaskIcon glyph="expand-more" className={styles.accordionExpandIcon} />;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t2) {
    t4 = <span className={styles.accordionSummaryContent}>{t2}{t3}</span>;
    $[6] = t2;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const t5 = `card-panel-content-${baseId}`;
  const t6 = `card-panel-header-${baseId}`;
  let t7;
  if ($[8] !== t5 || $[9] !== t6) {
    t7 = {
      "aria-controls": t5,
      id: t6,
      className: styles.accordionSummaryProps
    };
    $[8] = t5;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== detailsId || $[12] !== expandedByDefault) {
    t8 = {
      id: detailsId,
      open: expandedByDefault,
      className: styles.accordionDetails
    };
    $[11] = detailsId;
    $[12] = expandedByDefault;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== actionSection || $[15] !== analyticsActionName || $[16] !== detailsId) {
    t9 = <AccordionAnalyticsTracker detailsId={detailsId} analyticsActionName={analyticsActionName} actionSection={actionSection} />;
    $[14] = actionSection;
    $[15] = analyticsActionName;
    $[16] = detailsId;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  const t10 = `card-panel-content-${analyticsKey}-${productSlug || idSuffix}`;
  let t11;
  if ($[18] !== children || $[19] !== t10) {
    t11 = <div id={t10} className={styles.accordionContentPanel}>{children}</div>;
    $[18] = children;
    $[19] = t10;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== t11 || $[22] !== t4 || $[23] !== t7 || $[24] !== t8 || $[25] !== t9) {
    t12 = <Details variant="simple" SummaryComponent={t4} summaryProps={t7} detailsProps={t8}>{t9}{t11}</Details>;
    $[21] = t11;
    $[22] = t4;
    $[23] = t7;
    $[24] = t8;
    $[25] = t9;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  return t12;
}